<input
  #checkbox
  (click)="toggle()"
  [disabled]="disabled"
  [ngClass]="{ disabledBtn: disabled }"
  aria-pressed="false"
  id="{{ labelName }}"
  type="checkbox"
/>
<label class="checkbox ps-2 mt-1 pb-1">{{ labelName ? labelName : '' }}</label>
<pre *ngIf="environment.useDebugMode">isChecked: {{ isOn }}</pre>
